export default {
    publicRoutes: [
        '^/playground',
        '^/cookie-test',
        '^/advertiser-disclosure',
        '^/app',
        '^/application',
        '^/requirements',
        '^/test',
        '^/e2e-test-app/test-borrower-attributes',
        '^/basic-info',
        '^/e2e-test-app/test-basic-info',
        '^/funding-needs',
        '^/identity/sso',
        '^/guest/additional-owner',
        '^/login-error',
        '^/under-review',
        '^/business-credit-cards',
        '^/credit-card-widget', // Credit card widget
        '^/sba-application-widget', // SBA Application widget
        '^/credit-gathering-authorization',
        '^/healthcheck',
        '^/intelligent-lending$',
        '^/lender-profile',
        '^/lenders',
        '^/lendio-review',
        '^/login', // IMPORTANT - Do Not Remove unless path changes
        '^/nav',
        '^/owner-info$', // Owner info sub-paths should not be public.
        '^/owner-info/$', // Owner info sub-paths should not be public, but allow a trailing slash
        '^/reset', // IMPORTANT - Do Not Remove unless path changes
        '^/rollbar',
        '^/signup', // IMPORTANT - Do Not Remove unless path changes
        '^/staples-business-line-of-credit',
        '^/token', // IMPORTANT - Do Not Remove unless path changes
        '^/token-new',
        '^/top-lender-profile',
        '^/top-lenders',
        '^/404',
        '^/embedded/401',
        '^/qualifier',
        '^/waypoint-1',
        '^/sba-complete$',
        '^/sba-complete/basic-info$',
        '^/sba-complete/owner-info$',
        '^/document-upload-request/invite',
        '^/document-upload-request/invite-expired',
        '^/document-upload-request/contact-guest',
        '^/embedded/docusign-redirect', // DocuSign redirect handler for embedded users
        '^/bluevine', // Partner Signup - If matching route in legacy-redirects is removed, remove this
        '^/credibility-capital', // Partner Signup - If matching route in legacy-redirects is removed, remove this
        '^/fundbox', // Partner Signup - If matching route in legacy-redirects is removed, remove this
        '^/lendingclub', // Partner Signup - If matching route in legacy-redirects is removed, remove this
        '^/lendvantage', // Partner Signup - If matching route in legacy-redirects is removed, remove this
        '^/staples-business-loans', // Partner signup - If matching route in legacy-redirects is removed, remove this
        '^/upsstore', // Partner signup - If matching route in legacy-redirects is removed, remove this
        '^/app-switcher', // Temporary cookie setter to swap between SSR and static apps
    ],
    // Determine if path is publicly accessible
    isPublicRoute: function(route) {
        if (route.matched && !route.matched.length) {
            // If the route doesn't exist -- its safe for it to be considered public and 404
            return true
        }
        for (let i = 0; i < this.publicRoutes.length; i++) {
            if (RegExp(this.publicRoutes[i]).test(route.path)) {
                return true
            }
        }
        return false
    },

    testOnlyRoutes: [
      '^/form', // Universal App routes manage their own Auth/Allowance
    ],

    isTestOnlyRoute: function(route) {
      for (let i = 0; i < this.testOnlyRoutes.length; i++) {
        if (RegExp(this.testOnlyRoutes[i]).test(route.path)) {
            return true
        }
      }
      return false
    },
}
